document.addEventListener("DOMContentLoaded", function () {
  let proxyProductVariantId = "41747603882059";

  function toggleGiftWrapVisibility(checkbox, isInCart) {
    if (checkbox) {
      checkbox.checked = isInCart;
      const giftWrapWrapper = checkbox.closest('.giftwrap-wrapper');
      if (giftWrapWrapper) {
        if (isInCart) {
          giftWrapWrapper.style.setProperty('display', 'none', 'important');
          giftWrapWrapper.style.setProperty('visibility', 'hidden', 'important');
        } else {
          giftWrapWrapper.style.setProperty('display', 'block', 'important');
          giftWrapWrapper.style.setProperty('visibility', 'visible', 'important');
        }
      }
    }
  }

  function checkGiftWrapInCart(checkbox) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let giftWrapInCart = data.items.some(
          (item) => item.id == proxyProductVariantId
        );
        toggleGiftWrapVisibility(checkbox, giftWrapInCart);
      })
      .catch((error) => console.error("Error checking cart:", error));
  }

  function simulateClickOnProductRemove(id) {
    const cartDrawer = document.querySelector('[data-section-modification="drawer"]');
    
    if (cartDrawer && window.themeCore && window.themeCore.CartApi) {
      removeGiftWrapFromCart();
      return;
    }
    
    let closeButton = document.querySelector(`[data-item-id="${id}"]`);
    
    if (!closeButton) {
      closeButton = document.querySelector(`button[data-item-id="${id}"]`);
    }
    
    if (!closeButton) {
      const cartItems = document.querySelectorAll('.cart-item, .cart-items__item');
      cartItems.forEach(item => {
        const itemId = item.querySelector('[data-item-id]')?.getAttribute('data-item-id');
        if (itemId == id) {
          closeButton = item.querySelector('button[aria-label*="remove"], button[title*="remove"], .cart-item__remove, .cart-items__remove');
        }
      });
    }
    
    if (closeButton) {
      closeButton.click();
    } else {
      removeGiftWrapFromCart();
    }
  }

  function addGiftWrapToCart() {
    const checkbox = document.querySelector("#checkbox_giftwrap");
    if (checkbox) {
      checkbox.disabled = true;
    }
    
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const giftWrapInCart = data.items.some(item => item.id == proxyProductVariantId);
        if (giftWrapInCart) {
          if (checkbox) {
            checkbox.disabled = false;
          }
          return;
        }
        
        const cartDrawer = document.querySelector('[data-section-modification="drawer"]');
        
        if (cartDrawer && window.themeCore && window.themeCore.CartApi) {
          const sectionsIds = getCartSectionsIds();
          window.themeCore.CartApi.makeRequest(
            window.themeCore.CartApi.actions.ADD_TO_CART,
            { id: proxyProductVariantId, quantity: 1 },
            sectionsIds
          ).then((data) => {
            toggleGiftWrapVisibility(checkbox, true);
          }).catch((error) => {
            if (checkbox) {
              checkbox.disabled = false;
            }
            addGiftWrapViaFetch();
          });
        } else {
          addGiftWrapViaFetch();
        }
      })
      .catch((error) => {
        if (checkbox) {
          checkbox.disabled = false;
        }
        console.error("Error checking cart:", error);
      });
  }

  function addGiftWrapViaFetch() {
    const checkbox = document.querySelector("#checkbox_giftwrap");
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: proxyProductVariantId,
        quantity: 1
      })
    })
      .then((response) => response.json())
      .then((data) => {
        toggleGiftWrapVisibility(checkbox, true);
        refreshCart();
      })
      .catch((error) => {
        if (checkbox) {
          checkbox.disabled = false;
        }
        console.error("Error:", error);
      });
  }

  function getCartSectionsIds() {
    const sections = document.querySelectorAll('[data-section-type="cart-template"]');
    return Array.from(sections).map(section => section.dataset.sectionId).join(',');
  }

  function fetchProductByHandle(handle) {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .catch((error) => console.error("Error fetching product:", error));
  }

  function removeGiftWrapFromCart() {
    const cartDrawer = document.querySelector('[data-section-modification="drawer"]');
    
    if (cartDrawer && window.themeCore && window.themeCore.CartApi) {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          const giftWrapItem = cartData.items.find(item => item.id == proxyProductVariantId);
          if (giftWrapItem) {
            const sectionsIds = getCartSectionsIds();
            window.themeCore.CartApi.makeRequest(
              window.themeCore.CartApi.actions.REMOVE_CART_ITEM,
              giftWrapItem.key,
              sectionsIds
            ).then((data) => {
              const checkbox = document.querySelector("#checkbox_giftwrap");
              toggleGiftWrapVisibility(checkbox, false);
            }).catch((error) => {
              removeGiftWrapViaFetch();
            });
          }
        })
        .catch((error) => {
          removeGiftWrapViaFetch();
        });
    } else {
      removeGiftWrapViaFetch();
    }
  }

  function removeGiftWrapViaFetch() {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: proxyProductVariantId,
        quantity: 0
      })
    })
      .then((response) => response.json())
      .then((data) => {
        const checkbox = document.querySelector("#checkbox_giftwrap");
        toggleGiftWrapVisibility(checkbox, false);
        refreshCart();
      })
      .catch((error) => console.error("Error:", error));
  }

  function disableGiftWrap() {
    let checkbox = document.querySelector("#checkbox_giftwrap");
    if (checkbox) {
      checkbox.disabled = true;
      toggleGiftWrapVisibility(checkbox, false);
    }
  }

  function refreshCart() {
    const cartDrawer = document.querySelector('[data-section-modification="drawer"]');
    const cartPage = document.querySelector('.cart-template');
    
    if (cartDrawer && window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit("cart:refresh");
    } else if (cartPage) {
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else {
      document.dispatchEvent(new CustomEvent('cart::get'));
    }
  }

  function handleCartUpdates() {
    let cartPage = document.querySelector(".js-cart-container");
    let cartDrawer = document.querySelector('[data-section-modification="drawer"] .js-cart-container');
    
    const container = cartPage || cartDrawer;
    if (!container) {
      return;
    }

    let cartFormWrapper = container.querySelector(".cart-items");
    if (cartFormWrapper) {
      const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (mutation.type === "childList") {
            setTimeout(() => {
              const checkbox = document.querySelector("#checkbox_giftwrap");
              if (checkbox && !checkbox.hasAttribute('data-gift-wrap-setup')) {
                setupGiftWrap();
              } else {
                updateGiftWrapState();
              }
              handleCartChange();
            }, 100);
          }
        });
      });

      observer.observe(cartFormWrapper, { childList: true, subtree: true });
    }
  }

  function updateGiftWrapState() {
    const checkbox = document.querySelector("#checkbox_giftwrap");
    if (checkbox) {
      checkGiftWrapInCart(checkbox);
    }
  }

  function setupGiftWrap() {
    const checkbox = document.querySelector("#checkbox_giftwrap");
    
    if (checkbox && !checkbox.hasAttribute('data-gift-wrap-setup')) {
      checkbox.setAttribute('data-gift-wrap-setup', 'true');
      checkGiftWrapInCart(checkbox);
      return true;
    } else if (checkbox) {
      updateGiftWrapState();
      return true;
    } else {
      return false;
    }
  }

  function handleCartChange() {
    if (window.giftWrapTimeout) {
      clearTimeout(window.giftWrapTimeout);
    }
    
    window.giftWrapTimeout = setTimeout(() => {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
          if (data.items && data.items.length > 0) {
            let promises = data.items.map((item) =>
              fetchProductByHandle(item.handle)
            );

            Promise.all(promises).then((products) => {
              products.forEach((product) => {
                if (product && product.compare_at_price > product.price) {
                  removeGiftWrapFromCart();
                  disableGiftWrap();
                }
              });
            }).catch((error) => {
              console.error("Error processing products:", error);
            });
          }
        })
        .catch((error) =>
          console.error("Error checking cart for 'sale' items:", error)
        );
    }, 500);
  }

  document.addEventListener("cart::get", function (event) {
    handleCartChange();
  });

  if (window.themeCore && window.themeCore.EventBus) {
    window.themeCore.EventBus.listen("cart:updated", function (data) {
      setTimeout(() => {
        updateGiftWrapState();
      }, 200);
    });
    
    window.themeCore.EventBus.listen("cart:refresh", function (data) {
      setTimeout(() => {
        updateGiftWrapState();
      }, 200);
    });
  }

  let giftWrapClickTimeout;
  
  document.addEventListener('change', function(event) {
    if (event.target && event.target.id === 'checkbox_giftwrap') {
      if (giftWrapClickTimeout) {
        clearTimeout(giftWrapClickTimeout);
      }
      
      giftWrapClickTimeout = setTimeout(() => {
        if (event.target.checked) {
          addGiftWrapToCart();
        } else {
          simulateClickOnProductRemove(proxyProductVariantId);
        }
      }, 100);
    }
  });

  setTimeout(() => {
    setupGiftWrap();
  }, 100);
  
  handleCartUpdates();
  
  document.addEventListener('click', function(event) {
    const removeButton = event.target.closest('[data-item-key]');
    if (removeButton && removeButton.classList.contains('js-cart-item-remove')) {
      setTimeout(() => {
        updateGiftWrapState();
      }, 500);
    }
  });
});